<template>
	<div id="data-list-list-view" class="data-list-container">
		<vs-popup class="holamundo" :title="$t(`MODULE_PERMISSION.${titleModal}`)" :active.sync="addNewDataSidebar">
			<div class="p-2 py-0">
				<div>
					<label class="vs-input--label">{{ $t("MODULE_PERMISSION.labelRol") }}</label>
					<v-select
						multiple
						:closeOnSelect="false"
						v-model="selected"
						:options="roles"
						:dir="$vs.rtl ? 'rtl' : 'ltr'"
					>
						<template v-slot:no-options="{search, searching}">
							<template v-if="searching">
								{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
							</template>
							<template v-else>
								{{ $t("NoResultsFound") }}
							</template>
						</template>
					</v-select>
				</div>

				<vs-input
					:label="$t(`MODULE_PERMISSION.labelName`)"
					v-model="basic_info.name"
					class="mt-5 w-full"
					name="item-name"
					v-validate="'required'"
				/>
				<span class="text-danger text-sm" v-show="errors.has('item-name')">{{
					$t(`MODULE_PERMISSION.ValidName`)
				}}</span>
				<vs-textarea
					v-model="basic_info.description"
					:label="$t(`MODULE_PERMISSION.labelDescription`)"
					class="mt-5 w-full"
					name="item-description"
					v-validate="'required'"
				/>
				<span class="text-danger text-sm" v-show="errors.has('item-description')">{{
					$t(`MODULE_PERMISSION.ValidDescription`)
				}}</span>
				<div class="flex justify-end">
					<vs-button class="mr-5" color="success" type="border" @click="create">{{
						btnModalsubmit ? $t(`MODULE_PERMISSION.Create`) : $t(`MODULE_PERMISSION.Update`)
					}}</vs-button>
					<vs-button color="danger" type="border" @click="addNewDataSidebar = false">{{
						$t(`MODULE_PERMISSION.Cancel`)
					}}</vs-button>
				</div>
			</div>
		</vs-popup>
		<vx-card>
			<div id="div-with-loading-rol" class="vs-con-loading__container">
				<div class="flex flex-wrap-reverse items-center flex-grow justify-between">
					<div class="flex flex-wrap-reverse items-center data-list-btn-container mt-3">
						<!-- ADD NEW -->
						<div
							v-if="permissionCreatePermission"
							class="btn-add-new p-3 mb-4 mr-4 ml-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
							@click="addNewData"
						>
							<feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
							<span class="ml-2 text-base text-primary pr-2">{{ $t(`MODULE_PERMISSION.Add`) }}</span>
						</div>
					</div>
				</div>
				<div v-if="permissionReadPermission">
					<vs-table
						v-if="data != undefined"
						ref="table"
						pagination
						:max-items="itemsPerPage"
						search
						:data="data"
					>
						<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
							<div
								class="flex flex-wrap-reverse items-center data-list-btn-container mt-3 bottom-margin"
							></div>
							<!-- ITEMS PER PAGE -->
							<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
								<div
									class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
								>
									<span class="mr-2"
										>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }}
										-
										{{
											data.length - currentPage * itemsPerPage > 0
												? currentPage * itemsPerPage
												: data.length
										}}
										{{ $t("Of") }} {{ queriedItems }}</span
									>
									<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
								</div>
								<vs-dropdown-menu>
									<vs-dropdown-item @click="itemsPerPage = 4">
										<span>4</span>
									</vs-dropdown-item>
									<vs-dropdown-item @click="itemsPerPage = 10">
										<span>10</span>
									</vs-dropdown-item>
									<vs-dropdown-item @click="itemsPerPage = 15">
										<span>15</span>
									</vs-dropdown-item>
									<vs-dropdown-item @click="itemsPerPage = 20">
										<span>20</span>
									</vs-dropdown-item>
								</vs-dropdown-menu>
							</vs-dropdown>
						</div>
						<template slot="thead">
							<vs-th sort-key="name">{{ $t("MODULE_PERMISSION.Role") }}</vs-th>
							<vs-th sort-key="category">{{ $t("MODULE_PERMISSION.Description") }}</vs-th>
							<vs-th sort-key="popularity">{{ $t("MODULE_PERMISSION.Created") }}</vs-th>
							<vs-th v-if="permissionUpdatePermission || permissionDeletePermission">{{
								$t("MODULE_PERMISSION.Action")
							}}</vs-th>
						</template>
						<template slot-scope="{data}">
							<tbody>
								<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
									<vs-td>
										<p class="product-name font-medium truncate">
											{{ tr.name }}
										</p>
									</vs-td>
									<vs-td>
										<p class="product-category">
											{{ tr.description }}
										</p>
									</vs-td>
									<vs-td>
										<p class="product-price">
											{{ tr.added_on | formarDate }}
										</p>
									</vs-td>
									<vs-td
										class="whitespace-no-wrap"
										v-if="permissionUpdatePermission || permissionDeletePermission"
									>
										<feather-icon
											v-if="permissionUpdatePermission"
											icon="EditIcon"
											svgClasses="w-5 h-5 hover:text-primary stroke-current"
											@click.stop="editData(tr)"
										/>
										<feather-icon
											v-if="permissionDeletePermission"
											icon="TrashIcon"
											svgClasses="w-5 h-5 hover:text-danger stroke-current"
											class="ml-2"
											@click.stop="deleteData(tr.id)"
										/>
									</vs-td>
									<template class="expand-user" slot="expand" v-if="rol_permission != []">
										<div class="con-expand-users w-full">
											<div v-for="(cat, key) in rol_permission" :key="key">
												<vs-chip v-if="tr.id == cat.permission_id" transparent color="primary">
													{{ cat.role_name }}
												</vs-chip>
											</div>
										</div>
									</template>
								</vs-tr>
							</tbody>
						</template>
					</vs-table>
				</div>

				<not-permission v-else></not-permission>
			</div>
		</vx-card>
	</div>
</template>
<script>
import modulePermission from "./store/modulePermission.js";
import moduleRole from "@/store/roles/moduleRole.js";
import NotPermission from "@/views/pages/NotPermission.vue";
import {Validator} from "vee-validate";
import vSelect from "vue-select";
import {mapGetters, mapState} from "vuex";

const dict = {
	custom: {
		"item-name": {
			required: "ErrorName",
		},
		"item-description": {
			required: "ErrorDescription",
		},
	},
};

Validator.localize("en", dict);

export default {
	components: {
		vSelect,
		NotPermission,
	},
	data() {
		return {
			isLoading: true,
			selected: [],
			active: false,
			titleModal: "TitleCrear",
			idUpdate: "",
			idDelete: "",
			basic_info: {
				name: "",
				description: "",
			},
			itemsPerPage: 10,
			isMounted: false,
			addNewDataSidebar: false,
		};
	},
	watch: {
		id_permission(data) {
			if (data !== null) {
				this.selected = this.filterRolPermission.map((dato) => {
					return {
						value: dato.role_id,
						label: dato.role_name,
					};
				});
			}
		},
		data(newval, oldval) {
			if (this.$store.state.dataPermission.data.length > 0) {
				this.$vs.loading.close("#div-with-loading-rol > .con-vs-loading");
			}
		},
	},
	computed: {
		...mapState("dataPermission", ["id_permission", "rol_permission"]),
		...mapGetters("dataPermission", ["filterRolPermission"]),
		btnModalsubmit() {
			return this.titleModal === "TitleCrear";
		},
		currentPage() {
			if (this.isMounted) {
				if (this.$refs.table) return this.$refs.table.currentx;
			}
			return 0;
		},
		data() {
			return this.$store.state.dataPermission.data;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.data.length;
		},
		roles() {
			const roles = this.$store.state.dataRoles.roles;
			return roles.map((rol) => {
				return {
					value: rol.id,
					label: rol.name,
				};
			});
		},
		permissionCreatePermission() {
			return this.$store.getters.checkPermission("PERMISSION_C");
		},
		permissionReadPermission() {
			return this.$store.getters.checkPermission("PERMISSION_R");
		},
		permissionUpdatePermission() {
			return this.$store.getters.checkPermission("PERMISSION_U");
		},
		permissionDeletePermission() {
			return this.$store.getters.checkPermission("PERMISSION_D");
		},
	},
	methods: {
		async create() {
			try {
				const result = await this.$validator.validateAll();
				if (result) {
					this.addNewDataSidebar = false;
					this.$vs.loading({
						container: "#div-with-loading-rol",
						scale: 1,
						type: "sound",
					});

					if (this.btnModalsubmit) {
						const id = await this.$store.dispatch("dataPermission/createApi", this.basic_info);

						if (this.selected.length > 0) {
							const ids_roles = this.selected.map((rol) => rol.value);
							const data = {
								id: id,
								roles: ids_roles,
							};
							this.$store
								.dispatch("dataPermission/rolPermission", data)
								.then((r) => {
									this.$vs.loading.close("#div-with-loading-rol > .con-vs-loading");
									this.idUpdate = "";
									this.selected = [];
									this.$store.commit("dataPermission/GET_ID_ROL", null);
									this.basic_info = {
										name: "",
										description: "",
									};
									this.notyfy(
										this.$t("MODULE_PERMISSION.Hecho"),
										this.$t("MODULE_PERMISSION.msgHecho")
									);
								})
								.catch((err) => {
									console.error("Create Permission Error", err);
								});
						}
						await this.$store.dispatch("dataPermission/getApi");
					} else {
						const data = {
							id: this.idUpdate,
							payload: this.basic_info,
						};

						await this.$store.dispatch("dataPermission/deleteRolPermission");

						if (this.selected.length > 0) {
							const ids_roles = this.selected.map((rol) => rol.value);
							const data = {
								id: this.id_permission,
								roles: ids_roles,
							};

							await this.$store.dispatch("dataPermission/rolPermission", data);
						}
						this.$store
							.dispatch("dataPermission/updateApi", data)
							.then((r) => {
								this.$vs.loading.close("#div-with-loading-rol > .con-vs-loading");
								this.idUpdate = "";
								this.selected = [];
								this.$store.commit("dataPermission/GET_ID_ROL", null);
								this.basic_info = {
									name: "",
									description: "",
								};
								this.notyfy(
									this.$t("MODULE_PERMISSION.Change"),
									this.$t("MODULE_PERMISSION.msgChange")
								);
							})
							.catch((error) => {
								console.error("Create Permission Error", error);
							});
					}
				}
			} catch (e) {
				// statements
				console.error(e);
			} finally {
				this.$vs.loading.close("#div-with-loading-rol > .con-vs-loading");
			}
		},
		deleteData(id) {
			this.idDelete = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t(`MODULE_PERMISSION.titleDelete`),
				text: this.$t(`MODULE_PERMISSION.msgDelete`),
				accept: this.acceptAlert,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		async acceptAlert() {
			try {
				this.$vs.loading({
					container: "#div-with-loading-rol",
					scale: 1,
					type: "sound",
				});
				await this.$store.dispatch("dataPermission/deleteApi", this.idDelete);
				this.notyfy(this.$t("MODULE_PERMISSION.Removed"), this.$t("MODULE_PERMISSION.msgRemoved"));
			} catch (e) {
				console.error(e);
			} finally {
				this.$vs.loading.close("#div-with-loading-rol > .con-vs-loading");
				this.idDelete = "";
			}
		},
		addNewData() {
			this.titleModal = "TitleCrear";
			this.basic_info = {
				name: "",
				description: "",
			};
			this.selected = [];
			this.$nextTick(() => {
				this.errors.clear();
				this.$nextTick(() => {
					this.$validator.reset();
				});
			});
			this.toggleDataSidebar(true);
		},
		editData(data) {
			this.$store.commit("dataPermission/GET_ID_ROL", data.id);
			this.titleModal = "TitleUpdate";
			this.idUpdate = data.id;
			this.basic_info = {
				name: data.name,
				description: data.description,
			};
			this.toggleDataSidebar(true);
		},
		toggleDataSidebar(val = false) {
			this.addNewDataSidebar = val;
			this.errors.clear();
		},
		notyfy(title, text, color = "success", position = "bottom-right") {
			this.$vs.notify({
				color: color,
				title: title,
				text: text,
				position: position,
			});
		},
	},
	beforeCreate() {
		if (!modulePermission.isRegistered) {
			this.$store.registerModule("dataPermission", modulePermission);
			modulePermission.isRegistered = true;
		}
	},
	created() {
		if (!moduleRole.isRegistered) {
			this.$store.registerModule("dataRoles", moduleRole);
			moduleRole.isRegistered = true;
		}

		this.$vs.loading();

		this.$store.dispatch("dataPermission/getApi");
		this.$store.dispatch("dataRoles/getRoles").then((res) => {
			this.$vs.loading.close();
		});
	},
	mounted() {
		this.isMounted = true;
	},
};
</script>
<style lang="scss">
@import "./style.scss";

.bottom-margin {
	margin-bottom: 10px;
}

.header-sidebar {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	width: 100%;
	h4 {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		> button {
			margin-left: 10px;
		}
	}
}

.footer-sidebar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	> button {
		border: 0px solid rgba(0, 0, 0, 0) !important;
		border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
		border-radius: 0px !important;
	}
}
</style>
